export default __webpack_public_path__ + "static/MEXICO-2b0e8096d827f4d37f634157ba22655c.svg";